class NotifDispatchAccept {
  process (VueApp, payload) {
    VueApp.$store.commit('dispatch/showDispatchAcceptNotification', {
      show: true,
      accept: payload.accept === 'true',
      isPackage: payload.isPackage === 'true',
      id: parseInt(payload.id),
      driverId: payload.driverId === '' ? payload.driverId : parseInt(payload.driverId),
      driverName: payload.driverName,
      runsDeclined: false
    })
  }
}

export default new NotifDispatchAccept()



// WEBPACK FOOTER //
// ./src/modules/notifications/notif-dispatch-accept.js